import { useMutation, useQueryClient } from "react-query";
import { AxiosInstance } from "axios";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { useClient } from "utils/client";
import { ControlContext } from "context/Controls";

interface UpdateRiskGroupingTemplateInput {
  crn: string;
  id: string;
  label: string;
  description: string;
  members: string[];
}

const updateRiskGroupingTemplate = async (
  client: AxiosInstance,
  group: UpdateRiskGroupingTemplateInput
) => {
  const { data } = await client.put(`/risk-grouping-templates/${group.crn}`, {
    payload: group,
  });
  return data;
};

export const useUpdateRiskGroupingTemplate = () => {
  const client = useClient();
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { displayNotification } = useContext(ControlContext);

  return useMutation(
    async (group: UpdateRiskGroupingTemplateInput) =>
      await updateRiskGroupingTemplate(client, group),
    {
      onSettled: () => {
        queryClient.refetchQueries(["riskGroupingTemplates"]);
      },
      onError: (e) => {
        displayNotification!(
          t("riskTemplate.groupings.error_update"),
          (e as Error).message,
          "error"
        );
      },
    }
  );
};
